import {
  DebugLogger,
  ErrorLogger,
  InfoLogger,
  WarnLogger,
  SystemLogger
} from '../loggerTypes';
import { updateBareboneLogger } from '../newInternalLogger';
import { LevelLogProps } from '../types';

// Barebone Logger Factory
export const createBareboneLogger = (): void => {
  const minimalLevelLoggerProps: LevelLogProps = {
    shouldCallNativeLog: false,
    shouldCallBrowserLog: true,
    serviceName: '@clientos/commons-northbound-api'
  };

  updateBareboneLogger({
    debug: new DebugLogger(minimalLevelLoggerProps).getLogs(),
    log: new InfoLogger(minimalLevelLoggerProps).getLogs(),
    warn: new WarnLogger(minimalLevelLoggerProps).getLogs(),
    error: new ErrorLogger(minimalLevelLoggerProps).getLogs(),
    system: new SystemLogger(minimalLevelLoggerProps).getLogs()
  });
};
